const initialState = {
  message: null,
  user: null,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case 'user/set':
      return {
        message: action.payload?.message ?? state.message,
        user: action.payload?.user ?? action.payload ?? null,
      };
    case 'user/clear':
      return initialState;
    default:
      return state;
  }
}

export function setUser(payload) {
  return { type: 'user/set', payload };
}

export function clearUser() {
  return { type: 'user/clear' };
}
